"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8733],{

/***/ 81343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25400);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17847);
// Generated by ReScript, PLEASE EDIT WITH CARE



function DeviceSizeImage(props) {
    var mobile = props.mobile;
    var tablet = props.tablet;
    var smallScreen = props.smallScreen;
    var desktop = props.desktop;
    var images;
    if (desktop !== undefined) {
        var d = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(desktop);
        if (smallScreen !== undefined) {
            var s = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(smallScreen);
            if (tablet !== undefined) {
                var t = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(tablet);
                images = mobile !== undefined ? {
                    desktop: d,
                    smallScreen: s,
                    tablet: t,
                    mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
                } : {
                    desktop: d,
                    smallScreen: s,
                    tablet: t,
                    mobile: t
                };
            } else {
                images = mobile !== undefined ? {
                    desktop: d,
                    smallScreen: s,
                    tablet: s,
                    mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
                } : {
                    desktop: d,
                    smallScreen: s,
                    tablet: s,
                    mobile: s
                };
            }
        } else if (tablet !== undefined) {
            var t$1 = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(tablet);
            images = mobile !== undefined ? {
                desktop: d,
                smallScreen: d,
                tablet: t$1,
                mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
            } : {
                desktop: d,
                smallScreen: d,
                tablet: t$1,
                mobile: t$1
            };
        } else {
            images = mobile !== undefined ? {
                desktop: d,
                smallScreen: d,
                tablet: d,
                mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
            } : {
                desktop: d,
                smallScreen: d,
                tablet: d,
                mobile: d
            };
        }
    } else if (smallScreen !== undefined) {
        var s$1 = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(smallScreen);
        if (tablet !== undefined) {
            var t$2 = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(tablet);
            images = mobile !== undefined ? {
                desktop: s$1,
                smallScreen: s$1,
                tablet: t$2,
                mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
            } : {
                desktop: s$1,
                smallScreen: s$1,
                tablet: t$2,
                mobile: t$2
            };
        } else {
            images = mobile !== undefined ? {
                desktop: s$1,
                smallScreen: s$1,
                tablet: s$1,
                mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
            } : {
                desktop: s$1,
                smallScreen: s$1,
                tablet: s$1,
                mobile: s$1
            };
        }
    } else if (tablet !== undefined) {
        var t$3 = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(tablet);
        images = mobile !== undefined ? {
            desktop: t$3,
            smallScreen: t$3,
            tablet: t$3,
            mobile: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile)
        } : {
            desktop: t$3,
            smallScreen: t$3,
            tablet: t$3,
            mobile: t$3
        };
    } else if (mobile !== undefined) {
        var m = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(mobile);
        images = {
            desktop: m,
            smallScreen: m,
            tablet: m,
            mobile: m
        };
    } else {
        images = {
            desktop: null,
            smallScreen: null,
            tablet: null,
            mobile: null
        };
    }
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                greaterThanOrEqual: "rbDesktop",
                children: images.desktop
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                at: "rbSmallScreen",
                children: images.smallScreen
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                at: "rbTablet",
                children: images.tablet
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                at: "rbMobile",
                children: images.mobile
            })
        ]
    });
}
var make = DeviceSizeImage;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 96020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ make; }
});

// UNUSED EXPORTS: Slide, Styles, SwiperAutoplay, SwiperCore, SwiperPagination

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/utils/dom.js + 1 modules
var dom = __webpack_require__(1936);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/utils/utils.js
var utils = __webpack_require__(69759);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/components/pagination/pagination.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = (0,dom/* default */.Z)(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find((0,utils/* classesToSelector */.Wc)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find((0,utils/* classesToSelector */.Wc)(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find((0,utils/* classesToSelector */.Wc)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find((0,utils/* classesToSelector */.Wc)(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = (0,utils/* createElementIfNotDefined */.Up)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = (0,dom/* default */.Z)(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', (0,utils/* classesToSelector */.Wc)(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = (0,dom/* default */.Z)(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    (0,utils/* extend */.l7)(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', (0,utils/* classesToSelector */.Wc)(params.bulletClass));
    }
  }
};
/* harmony default export */ var pagination = ({
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,utils/* bindModuleMethods */.cR)(swiper, {
      pagination: _extends({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0,dom/* default */.Z)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
});
// EXTERNAL MODULE: ./node_modules/ssr-window/ssr-window.esm.js
var ssr_window_esm = __webpack_require__(6156);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/components/autoplay/autoplay.js
function autoplay_extends() { autoplay_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return autoplay_extends.apply(this, arguments); }

/* eslint no-underscore-dangle: "off" */


var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = (0,utils/* nextTick */.Y3)(function () {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
        swiper.autoplay.run();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
      });
    }
  },
  onVisibilityChange: function onVisibilityChange() {
    var swiper = this;
    var document = (0,ssr_window_esm/* getDocument */.Me)();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      swiper.autoplay.run();
      swiper.autoplay.paused = false;
    }
  },
  onTransitionEnd: function onTransitionEnd(e) {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.run();
    }
  },
  onMouseEnter: function onMouseEnter() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
  },
  onMouseLeave: function onMouseLeave() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    swiper.autoplay.run();
  },
  attachMouseEvents: function attachMouseEvents() {
    var swiper = this;

    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
    }
  },
  detachMouseEvents: function detachMouseEvents() {
    var swiper = this;
    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
  }
};
/* harmony default export */ var autoplay_autoplay = ({
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  },
  create: function create() {
    var swiper = this;
    (0,utils/* bindModuleMethods */.cR)(swiper, {
      autoplay: autoplay_extends({}, Autoplay, {
        running: false,
        paused: false
      })
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        var document = (0,ssr_window_esm/* getDocument */.Me)();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        swiper.autoplay.attachMouseEvents();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove(swiper) {
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd(swiper) {
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy(swiper) {
      swiper.autoplay.detachMouseEvents();

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      var document = (0,ssr_window_esm/* getDocument */.Me)();
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Js_Core.bs.js
var Css_Js_Core_bs = __webpack_require__(32885);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(74124);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/react/swiper.js + 10 modules
var swiper = __webpack_require__(56355);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(73063);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE












var carousel = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE("a", [
        BsCssJs_bs/* textDecoration */.QXS("none"),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* flex3 */.L9u(0, 0, BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* display */.jfB("flex")
    ])
]);
function FullWidthCarousel_bs_pagination(theme) {
    var match = theme.components;
    var fullWidthCarousel = match.fullWidthCarousel;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* justifyContent */.KlP("center"),
        BsCssJs_bs/* flexWrap */.WOS("wrap"),
        BsCssJs_bs/* width */.bf$("auto"),
        BsCssJs_bs/* left */.t$v("auto"),
        BsCssJs_bs/* right */.F2z("auto"),
        BsCssJs_bs/* bottom */.IaC("auto"),
        BsCssJs_bs/* top */.wey("auto"),
        BsCssJs_bs/* boxSizing */.ixg("borderBox"),
        BsCssJs_bs/* important */.efO(BsCssJs_bs/* position */.FKU("relative")),
        BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(18)),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, [
            BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(30))
        ]),
        BsCssJs_bs/* selector */.nZE(".swiper-pagination-bullet", [
            BsCssJs_bs/* width */.bf$(BsCssJs_bs.px(12)),
            BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(12)),
            BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs/* pct */.hdZ(50)),
            BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs.px(1)),
            BsCssJs_bs/* borderStyle */.$uf("solid"),
            BsCssJs_bs/* borderColor */.tvt(Theme_Color_bs/* white */.ix),
            BsCssJs_bs/* backgroundColor */.Czw(fullWidthCarousel.paginationColour),
            BsCssJs_bs/* margin */.e6$(BsCssJs_bs.px(6)),
            BsCssJs_bs/* boxSizing */.ixg("borderBox"),
            BsCssJs_bs/* opacity */.Ohi(1)
        ]),
        BsCssJs_bs/* selector */.nZE(".swiper-pagination-bullet.swiper-pagination-bullet-active", [
            BsCssJs_bs/* backgroundColor */.Czw(fullWidthCarousel.activePaginationColour),
            BsCssJs_bs/* boxShadow */.Wnp(Css_Js_Core_bs/* Shadow.box */.jXB.box(BsCssJs_bs.px(0), BsCssJs_bs.px(0), BsCssJs_bs.px(0), BsCssJs_bs.px(1), undefined, fullWidthCarousel.activePaginationColour))
        ])
    ]);
}
var Styles = {
    carousel: carousel,
    pagination: FullWidthCarousel_bs_pagination
};
function FullWidthCarousel(props) {
    var className = props.className;
    var autoplay = props.autoplay;
    var showPagination = props.showPagination;
    var showPagination$1 = showPagination !== undefined ? showPagination : true;
    var autoplay$1 = autoplay !== undefined ? autoplay : false;
    var className$1 = className !== undefined ? className : "";
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    curry._1(core_class/* default.use */.Z.use, [
        pagination,
        autoplay_autoplay
    ]);
    var swiperAutoplay = {
        enabled: autoplay$1,
        delay: 5000,
        disableOnInteraction: true
    };
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(swiper/* Swiper */.t, {
                autoplay: swiperAutoplay,
                children: props.children,
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    dynamicBullets: false,
                    dynamicMainBullets: 1,
                    clickable: true
                }
            }),
            showPagination$1 ? jsx_runtime.jsx("div", {
                className: classnames_default()([
                    "swiper-pagination",
                    FullWidthCarousel_bs_pagination(theme)
                ])
            }) : null
        ],
        className: classnames_default()([
            carousel,
            className$1
        ])
    });
}
var Slide;
var SwiperCore;
var SwiperPagination;
var SwiperAutoplay;
var make = FullWidthCarousel;
 /*  Not a pure module */ 


/***/ }),

/***/ 29261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Background, Content, Icon, Description, Footer, Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var slide = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("relative"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flex3 */ .L9u(1, 1, "auto"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100))
]);
var Styles = {
    slide: slide
};
function FullWidthCarousel__Slide(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            slide,
            className$1
        ])
    });
}
var Background;
var Content;
var Icon;
var Description;
var Footer;
var make = FullWidthCarousel__Slide;
 /* slide Not a pure module */ 


/***/ }),

/***/ 32426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var content = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("relative"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5D(1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding2 */ .BLt(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(32), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(37)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .boxSizing */ .ixg("borderBox"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSmUp */ .Uv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding2 */ .BLt(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(32), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(66))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding2 */ .BLt(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(65), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(55)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin2 */ .h9x("zero", "auto")
    ])
]);
var Styles = {
    content: content
};
function FullWidthCarousel__SlideContent(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            content,
            className$1
        ])
    });
}
var make = FullWidthCarousel__SlideContent;
 /* content Not a pure module */ 


/***/ }),

/***/ 22492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Styles": function() { return /* binding */ Styles; },
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28522);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





function themeStyles(theme) {
    var match = theme.components;
    var tag = match.tag;
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor */ .Czw(tag.backgroundColor),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(tag.color)
    ]);
}
var tag = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("inlineBlock"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(14)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8({
        NAME: "abs",
        VAL: 1.5
    }),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue2("semiBold"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius */ .E0l(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(22)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingLeft */ .rv2(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingRight */ .WLm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.25)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.25)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .smallScreenOrMobile */ .HH, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(12))
    ])
]);
var Styles = {
    themeStyles: themeStyles,
    tag: tag
};
function Tag(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var theme = _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg(undefined);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("span", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            tag,
            themeStyles(theme),
            className$1
        ])
    });
}
var make = Tag;
 /* tag Not a pure module */ 


/***/ }),

/***/ 78804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92592);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31420);
// Generated by ReScript, PLEASE EDIT WITH CARE







var closeButton = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .background */ .Oq0("transparent"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .border */ .CgR(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(0), "solid", "transparent"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding */ .o3D(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Personal.white */ .RL.white),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("absolute"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2z(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(-30)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .wey(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(-5)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(30)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .hover */ .MrM([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .cursor */ .ocY("pointer")
    ])
]);
var Styles = {
    closeButton: closeButton
};
function Modal__Close(props) {
    var closeFunc = props.closeFunc;
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("button", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__.FontAwesomeIcon, {
            icon: _fortawesome_pro_regular_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_5__/* .faTimes */ .NB
        }),
        "aria-label": "Close modal",
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            closeButton,
            className$1
        ]),
        onClick: function onClick(param) {
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(closeFunc, undefined);
        }
    });
}
var make = Modal__Close;
 /* closeButton Not a pure module */ 


/***/ })

}]);